import React from "react";
import { Box, Typography } from "@mui/material";
import globalStyles from "../../global";
import { useTranslation } from "react-i18next";

const GlobalBand = ({ countryCode = "uae" }) => {
  const { t, i18n } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
  const isRTL = i18n.language === "ar";
  const backgroundImage = `${imageBaseUrl}background_border.svg`;

  const styles = {
    container: {
      backgroundColor: globalStyles.colors.army_green,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "scroll",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: globalStyles.colors.white,
      position: "relative",
      overflow: "hidden",
      direction: isRTL ? "rtl" : "ltr",
      minHeight: {
        xs: "96px",
        sm: "110px",
        md: "120px",
        lg: "140px",
        xl: "160px",
      },
      py: {
        xs: 1.5,
        sm: 2,
        md: 2.5,
      },
      px: {
        xs: 1,
        sm: 2,
      },
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundSize: {
          xs: "contain",
          sm: "cover",
          md: "cover",
        },
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        opacity: 0.8,
        zIndex: 1,
      },
    },
    text: {
      fontWeight: 600,
      fontSize: { xs: "24px", sm: "38px", md: "40px" } ,
      color: globalStyles.colors.white,
      textAlign: "center",
      lineHeight: 1.3,
      textTransform: "uppercase",
      maxWidth: "98%",
      position: "relative",
      zIndex: 2,
      letterSpacing: ".5px",
    },
  };

  // Split the text for 2-line appearance (after comma)
  const text = t("countryBandGlobal.text");
  let lines = text.split(",");
  if (lines.length === 1) {
    // fallback: try splitting at ~40 chars
    const idx = text.indexOf(" ", Math.floor(text.length / 2));
    lines = [text.substring(0, idx), text.substring(idx + 1)];
  }

  return (
    <Box
      sx={{
        ...styles.container,
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <Typography variant="h1_gothic" sx={styles.text}>
        {lines.map((line, idx) => (
          <React.Fragment key={idx}>
            {line.trim()}
            {idx !== lines.length - 1 && <br />}
          </React.Fragment>
        ))}
      </Typography>
    </Box>
  );
};

export default GlobalBand;